




















































































import { updateEnrollee } from '@adobe/edex/frontend/api/course';
import EnrolleeActions from '@adobe/edex/frontend/views/course/manage/course-manage-actions.vue';

export default {
  name: 'enrollee-row',
  components: {
    EnrolleeActions,
  },
  props: {
    permissions: {
      required: true,
      type: Object,
    },
    index: {
      type: Number,
    },
    enrollee: {
      default: () => {
        return {};
      },
      type: Object,
    },
    selected: {
      default: () => {
        return new Set();
      },
      type: Set,
    },
  },
  data() {
    return {
      isSelected: this.selected.has(this.enrollee.memberID),
      toggleLoading: false,
    };
  },
  watch: {
    selected(value) {
      if (value.has(this.enrollee.memberID)) {
        this.isSelected = true;
      } else {
        this.isSelected = false;
      }
    },
  },
  computed: {
    lastActivity() {
      return (
        this.enrollee.lastActivityAt &&
        this.lzDateFmt(this.enrollee.lastActivityAt)
      );
    },
    enrolled() {
      return this.enrollee.createdAt && this.lzDateFmt(this.enrollee.createdAt);
    },
    started() {
      return this.enrollee.startedAt && this.lzDateFmt(this.enrollee.startedAt);
    },
    completed() {
      return this.enrollee.meta.passed
        ? this.lzDateFmt(this.enrollee.completedAt)
        : '';
    },
  },
  methods: {
    async toggleComplete({ value }) {
      const { memberID, courseID } = this.enrollee;
      const status = value ? 'passed' : 'pending-review';
      this.toggleLoading = true;
      try {
        const payload = {
          memberID,
          status,
        };

        const { data } = await updateEnrollee(courseID, payload);

        if (data) {
          this.$emit('onRowUpdated', data);
        }
      } catch (error) {
        this.$emit('onRowUpdatedError');
      }

      this.toggleLoading = false;
    },
    select() {
      if (this.isSelected) {
        this.$emit('unselected', this.enrollee.memberID);
      } else {
        this.$emit('selected', this.enrollee.memberID);
      }
    },
  },
};
